import { Component, OnInit } from '@angular/core';
import { EoptionsService } from 'src/app/services/eoptions.service';

@Component({
    selector: 'app-eoptions-trade',
    templateUrl: './eoptions-trade.component.html',
    styleUrls: ['./eoptions-trade.component.css']
})
export class EOptionsTradeComponent implements OnInit {
    viewMode: 'TABLE' | 'CHART' = 'TABLE';

    hasSelectedContract: boolean = false;

    constructor(private eoptionsService: EoptionsService) { }

    ngOnInit(): void {
        this.eoptionsService.viewMode$.subscribe(mode => {
            this.viewMode = mode;
        });

        this.eoptionsService.selectedContract$.subscribe(contract => {
            this.hasSelectedContract = !!contract;
        });
    }
}
